import type * as React from 'react';
const SvgIcoAdd = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M19.5 13h-6v6h-2v-6h-6v-2h6V5h2v6h6z" fill="currentColor" />
  </svg>
);
export default SvgIcoAdd;
